import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportAccumulatedDiscountTypes } from "redux/reducers/Reports/reportAccumulatedDiscount/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_ACCUMULATED_DISCOUNT_FILTERS } = reportAccumulatedDiscountTypes;

export const getReportAccumulatedDiscountAction = ({ startDate, endDate, station, isPdf = true }) => {
  const token = localStorage.getItem('crm-user');
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/accumulatedDiscount?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
  const fileName = `Reporte_Descuentos_Acumulados_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

  return async dispatch => {
    dispatch(startRequestComp('loadingAccumulatedDiscount'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingAccumulatedDiscount'));
    }
  };
};

export const setReportAccumulatedDiscountFilters = (key = "", value) => ({
  type: SET_ACCUMULATED_DISCOUNT_FILTERS,
  payload: { key, value }
});
